import { SxProps } from '@mui/material';

export const CustomDialogContentStyle: SxProps = {
  '&.MuiDialogContent-root': {
    p: 2,
  },
  minHeight: '250px',
};
